export default __webpack_public_path__ + "static/media/google.03134713.svg";